import { featureFlags } from '../../_constants/feature_flags';
export default () => {
    const { FEATURE_FSF_FLOW_DISABLED } = featureFlags;
    return FEATURE_FSF_FLOW_DISABLED;
}